module.exports = __webpack_public_path__ + "static/media/empty.9d046b10.svg";